var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:_vm.$style.button,on:{"click":_vm.toTop}},[_c('div',{class:_vm.$style.arrow_top})])])}
var staticRenderFns = []

export { render, staticRenderFns }